import request from '@/utils/request'

// 查询联盟邀请成员（邀请人员）分页
export function pageUnionInviteMember(query) {
  return request({
    url: '/union/union/invite/member/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
